import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 8px;
  font: normal normal normal 14px/17px Inter;
  color: ${props => props.theme.colors.color6b7786};

  margin-bottom: -18px;
`

export const Label = styled.span`
  font-weight: bold;
`

export const Value = styled.p`
  line-height: 20px;
  white-space: pre-wrap;

  height: 100%;
  b {
    font-weight: bold;
  }
`
export const ValueHTML = styled.p`
  height: 100%;
  word-break: break-word;
  b {
    font-weight: bold;
  }
`
